export const SCREEN = {
  SUMMARY: 'SUMMARY',
  COMPANY_PROFILE: 'COMPANY_PROFILE',
  FILING_STATUS: 'FILING_STATUS',
  FINANCIAL_STATEMENT: 'FINANCIAL_STATEMENT',
  FINANCIAL_ANALYSIS: 'FINANCIAL_ANALYSIS',
  SCORE: 'SCORE',
  PEER_ANALYSIS: 'PEER_ANALYSIS',
  INDUSTRY_OVERVIEW: 'INDUSTRY_OVERVIEW',
  INDUSTRY_ANALYSIS: 'INDUSTRY_ANALYSIS',
  DYNAMIC_REPORT: 'DYNAMIC_REPORT',

  PORTFOLIO_INSIGHTS: 'PORTFOLIO_INSIGHTS',
  PORTFOLIO_INSIGHTS_FINANCE: 'PORTFOLIO_INSIGHTS_FINANCE',
}

export const SCROLL_ID_HIDDEN = ['companyAnalysis']
